<template>
  <div class="corporate-tournament">
    <div class="top-corporate">
      <img
        @click="GoHome"
        src="../../src/assets/basketballActivities/logo.png"
        alt=""
        style="cursor:pointer"
      />
      <p>{{ $t('corporate.landing_title') }}</p>
    </div>
    <div class="banner" style="min-height:583px;">
      <img
        v-if="showMobile"
        :src="require('../assets/corporate-banner-update-mobile.webp')"
        style="width:100%"
      />
      <img
        v-else
        :src="require('../assets/corporate_banner.jpeg')"
        style="width:100%"
      />
    </div>
    <!-- <p class="describe" v-html="$t('corporate.describe')"></p> -->
    <el-divider></el-divider>
    <div class="match-schedule">
      <div class="match-box">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item, index) in tabnames"
            :key="index"
            :label="$t('corporate.' + item.tabname)"
            :name="'tab' + (index + 1)"
          >
            <div class="match-tit" :style="{ background: '#318bc8' }">
              {{ $t('corporate.' + item.tabname) }}
            </div>
            <GroupStage
              v-if="item.id === 1"
              :teams="teams"
              v-loading="stageloading"
              :tabnames="groupstagetab"
              :activeNametab="groupstagetabactive"
              @handleDateChange="handleDateChange"
            />
            <MatchCom
              v-if="item.id === 2"
              :currentIndex="currentIndex"
              v-loading="metchLoading"
              :tabnames="groupstagetab"
              @teamId="teamId"
              :roundList="roundsList"
              :tabid="tabid"
              ref="current"
              :team="team"
            />
            <TournamentHiglight v-if="item.id === 3" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { BasketballApi } from '../api/basketball'
import MatchCom from './components/corporate/MatchCom.vue'
import GroupStage from './components/corporate/GroupStage.vue'
import TournamentHiglight from './components/corporate/TournamentHiglight.vue'

export default {
  components: {
    MatchCom,
    GroupStage,
    TournamentHiglight
  },
  data() {
    return {
      showMobile: false,
      showLogo: false,
      screenWidth: document.body.clientWidth,
      windowWidth: 0,
      imagesTournament: [
        {
          id: '1',
          big: '',
          thumb: ''
        }
      ],
      // tableData: [
      //   {}
      // ]
      currentIndex: 0,
      metchLoading: false,
      stageloading: false,
      tabnames: [
        { id: 1, tabname: 'tournament_introduction' },
        { id: 2, tabname: 'matchResults' },
        { id: 3, tabname: 'tournament_highlight' }
      ],
      team_id: '',
      roundsList: [],
      tabid: '2',
      team: [],
      activeName: 'tab1',
      teams: {},
      groupstagetab: [],
      groupstagetabactive: '',
      corporateChampion: '',
      corporateFile:
        'https://drive.google.com/drive/folders/1x4AK3OeRBGFbj2YSC23VoXCnVR8hkKvu?usp=sharing',
      corporateCaptionEn: '',
      corporateCaptionCn: '',
      isCorporatePath: false,
      lastPath: false
    }
  },
  watch: {
    headType() {
      this.monthtab()
    },
    screenWidth(val) {
      this.screenWidth = val
    },
    $route(to) {
      if (to.path == '/corporate') {
        this.isCorporatePath = true
      }
    }
  },
  methods: {
    showMobileBanner() {
      window.screenWidth = document.body.clientWidth
      this.screenWidth = window.screenWidth
      if (this.screenWidth < 500) {
        this.showMobile = true
      } else {
        this.showMobile = false
      }
      if (this.screenWidth <= 760) {
        this.showLogo = false
      } else {
        this.showLogo = true
      }
    },
    lastRouteName: function() {
      const history = this.$router.history.current.query.tab
      return history
    },
    teamId(val) {
      this.team_id = val
    },
    GoHome() {
      this.$router.push(`/`)
    },
    monthtab(val, index) {
      this.montabId = val
      this.currentIndex = index
    },
    handleClick(tab) {
      if (tab.index == 0) {
        tab.index = this.tabnames[0].id
        this.tabid = tab.index
        this.$router.push({ path: '/corporate?type=1' })
      } else if (tab.index == 1) {
        tab.index = this.tabnames[1].id
        this.tabid = tab.index
        this.getTeams('s')
        this.$router.push({ path: '/corporate?type=1' })
      } else if (tab.index == 2) {
        tab.index = this.tabnames[2].id
        this.tabid = tab.index
        this.getTeams('f')
      } else if (tab.index == 3) {
        tab.index = this.tabnames[3].id
        this.tabid = tab.index
        this.getTeams('g')
      }
      this.montabId = ''
      this.currentIndex = 0
    },
    tabchange(id) {
      this.id = id
    },
    handleDateChange(val) {
      this.stageloading = true
      BasketballApi.getTournamentsDetails(val).then((res) => {
        let arr = []
        res.groups.forEach((item) => {
          let obj = new Object()
          let companiesarr = []
          obj.name = `Group ${item.name}`
          item.companies.forEach((companyitem) => {
            companiesarr.push(companyitem.name)
          })
          obj.teamNames = companiesarr
          arr.push(obj)
        })
        this.teams = arr
      })
      this.stageloading = false
    },
    getGroupStage() {
      this.stageloading = true
      BasketballApi.getTournaments({ type: 'g' }).then((res) => {
        let arr = []
        res.forEach((item) => {
          let obj = new Object()
          obj.id = item.id.toString()
          obj.tabname = new Date(item.date).toLocaleDateString('en', {
            dateStyle: 'medium'
          })
          arr.push(obj)
        })
        this.groupstagetab = arr
        this.groupstagetabactive = this.groupstagetab[0].id
        this.handleDateChange(this.groupstagetab[0].id)
      })
      this.stageloading = false
    },
    //获取队伍列表
    getTeams(type) {
      this.metchLoading = true
      BasketballApi.getTournaments({ type: type }).then((res) => {
        this.team = res
      })
      this.metchLoading = false
    },
    statspage() {
      this.$router.push({ path: '/stats', query: { type: this.headType } })
    }
    // populateCorporateData() {
    //   BasketballApi.populateCorporateData()
    //     .then(({ data }) => {
    //       this.corporateChampion = data.photo_path_url;
    //       // this.corporateFile = data.file_path_url;
    //       this.corporateCaptionEn = data.link_en;
    //       this.corporateCaptionCn = data.link_cn;
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    //   BasketballApi.populateTournamentSlide()
    //     .then(({ data }) => {
    //       this.imagesTournament = [];
    //       data.forEach((data, index) => {
    //         let imgData = {
    //           id: index + 1,
    //           big: data.temp_photo_path_url,
    //           thumb: data.temp_photo_path_url
    //         };
    //         this.imagesTournament.push(imgData);
    //       });
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // }
  },
  computed: {
    ...mapState(['headType']),
    ...mapState(['headType', 'isCorporate'])
  },
  created() {
    this.getGroupStage()
    this.$store.commit('setPathType', true)
    this.path = this.$route.path
    if (this.path === `/corporate`) {
      this.isCorporatePath = true
    }
    if (this.lastRouteName() === 'highlight') {
      this.activeName = 'tab3'
    }
  },
  mounted() {
    // this.populateCorporateData();
    const that = this
    //当进入页面监听
    that.showMobileBanner()
    // 事件监听滚动条
    window.onresize = () => {
      return (() => {
        that.showMobileBanner()
      })()
    }
  }
}
</script>

<style lang="scss">
.corporate-tournament {
  .banner {
    width: 100%;
    margin-top: 0.5rem;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .el-table {
    color: #2c3e50;
    font-size: 15px;
  }
  .el-table th.el-table__cell > .cell {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    max-width: 1400px;
    margin: 0 auto;
    line-height: 1.42857143;
  }
  .el-divider--horizontal {
    height: 3px;
  }
}
</style>

<style lang="scss" scoped>
.corporate-tournament {
  .top-corporate {
    margin-block: 1em 2em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1em;

    @media screen and (min-width: 768px) {
      flex-direction: row;
    }

    p {
      // margin-left: 15px;
      color: #318bc9;
      font-size: 22px;
      font-weight: 600;
    }
  }

  .describe {
    margin: 20px 0;
  }

  .key-contents {
    align-content: center;
    width: 100%;
    padding: 20px;
    justify-content: space-between;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: -90px;

    .right {
      width: 50%;
      background: #318bc8;
      color: white;
      border-radius: 10px;

      .container-1 {
        margin: 10px;
        padding: 5px;
        color: white;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        align-content: center;
        justify-content: space-between;

        .name {
          font-weight: bold;
        }
      }
    }

    .container-2 {
      margin: 10px;
      width: 50%;
      color: white;
      border-radius: 10px;
      margin-top: 200px;
      background: lightblue;
      display: flex;
      height: 271px;
      font-size: 50px;
      align-content: center;
      flex-direction: column;
      justify-content: center;
    }

    .left {
      width: 50%;
      background: #318bc8;
      color: white;
      border-radius: 10px;
      margin-top: 200px;

      .container-4 {
        margin: 10px;
        padding: 5px;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        align-content: center;
        justify-content: space-between;

        .name {
          font-weight: bold;
        }
      }
    }

    .container-3 {
      margin: 10px;
      width: 50%;
      color: white;
      border-radius: 10px;
      background: lightblue;
      display: flex;
      height: 271px;
      font-size: 50px;
      align-content: center;
      flex-direction: column;
      justify-content: center;
    }
  }

  .match-schedule {
    padding-top: 1em;
    padding-bottom: 2em;
  }

  .match-box {
    padding-inline: 10px;
    box-shadow: 2px 2px 15px #8888886c;
    border-radius: 15px;
    overflow: hidden;

    .standing-bg {
      box-shadow: 2px 2px 15px #8888886c;
      background: #fff;
      display: flex;
      // border: 2px solid #c2cfe573;
      // border-bottom: none;
      border-radius: 20px 20px 0 0;

      // justify-content: space-around;
      .tab {
        padding: 20px 30px;
        cursor: pointer;
        font-size: 17px;
        color: #318bc8;
        border-radius: 18px 18px 0 0;
      }

      .active {
        // background-color: orange;
        color: #fff;
        background: #318bc8;
      }
    }

    .match-tit {
      background: #318bc8;
      line-height: 60px;
      text-align: left;
      padding-left: 35px;
      color: #fff;
      font-size: 20px;
      // border: 2px solid #fff;
      border-top: none;
    }

    .match-tab {
      .tab ul {
        overflow: hidden;
        margin-bottom: 2px;
        display: flex;
        margin-top: 15px;
        border-bottom: 2px solid rgb(238, 236, 236);
        justify-content: space-around;
      }

      .tab ul li {
        list-style: none;
        text-align: center;
        cursor: pointer;
        font-size: 17px;
        color: rgb(222, 228, 228);
        padding: 0 10px;
      }

      .tab ul li.active {
        // background-color: orange;
        color: #2d3b51;
        border-bottom: 3px solid #2d3b51;
      }

      .tab {
        .show-box {
          width: 100%;
          height: 100%;
          text-align: center;
          display: none;

          :hover {
            background: #eff5fa;
          }

          .tab-content {
            display: flex;
            justify-content: space-around;
            border-bottom: 2px solid #c5cfe348;
            // margin-top: 30px;

            .play-box {
              width: 20%;
              height: 100px;
              margin: 10px;
              padding-top: 10px;
            }

            .play-time,
            .play-tit,
            .play-stats {
              line-height: 25px;
              width: 17%;
              color: #2d3b51;
            }

            .play-team1,
            .play-team2 {
              width: 30%;
              display: flex;
              justify-content: center;
              padding-top: 30px;

              .play-txt1 {
                text-align: right;

                .sp1 {
                  color: #5aa2d3;
                }

                .sp2 {
                  font-size: 18px;
                  font-weight: 600;
                  color: #2d3b51;
                }
              }

              .play-txt2 {
                margin: 0 20px;
                margin-top: -10px;

                img {
                  border-radius: 10px;
                }
              }

              .play-txt3 {
                font-size: 30px;
                font-weight: 600;
                color: #c2cfe5;
              }
            }
          }

          .play-stats {
            p {
              margin-top: 30px;
              cursor: pointer;
            }

            i {
              color: #5aa2d3;
            }

            :hover {
              color: #5aa2d3;
            }
          }
        }
      }

      .tab .show-box.current {
        display: block;
      }
    }
  }
}

@media screen and (max-width: 1067px) {
  .corporate-tournament {
    .tables {
      .game-rules {
        margin-top: -11% !important;
      }
    }
  }
}

@media screen and (max-width: 940px) {
  .corporate-tournament {
    .tables {
      .game-rules {
        margin-top: -14% !important;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .corporate-tournament {
    .game-rules {
      margin-top: -13% !important;
    }
  }

  .gallery {
    display: grid;
    grid-template-columns: 1fr 1fr;

    .img-box {
      flex-direction: column;
      overflow-x: scroll;

      .img {
        width: 100%;
        margin-right: 10px;
      }
    }
  }
}
</style>
